module.exports = __webpack_public_path__ + "img/5.e47cbb2b.jpg";